import React from 'react';

import { styled } from '@material-ui/core/styles';

import { theme } from 'theme';

const Container = styled('div')({
  border: `0.5px solid ${theme.colors.primary.black}`,
  marginTop: '10px',
  padding: '10px',
});

const BoxContainer = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};

export default BoxContainer;
